import { NgModule } from "@angular/core";
import { BrowserModule } from "@angular/platform-browser";
import { RouterModule } from "@angular/router";
import { error404 } from "./error404.component";
import { error500 } from "./error500.component";

@NgModule({
    declarations: [error404,error500],
    imports: [BrowserModule, RouterModule],
    exports: [error404,error500]
})

export class ErrorModule { }


// WEBPACK FOOTER //
// C:/Fuentes Git/TecnienLineaV2.0/front-consulta-en-linea/src/app/components/common/errores/errores.module.ts